
import { BOOL } from "@/constant/system/enums"
import { listByDictCode } from "@/api/system/dictionary-data"

/**
 * 是或否
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const YON = {
  request: function() {
    return Promise.resolve([
      {
        label: '是',
        value: BOOL.TRUE
      }, {
        label: '否',
        value: BOOL.FALSE
      }
    ])
  }
}
/**
 * Bool是或否
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const BYON = {
  request: function() {
    return Promise.resolve([
      {
        label: '是',
        value: true
      }, {
        label: '否',
        value: false
      }
    ])
  }
}

/**
 * 启用或停用
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const EOD = {
  request: function() {
    return Promise.resolve([{
      label: '启用',
      value: BOOL.TRUE
    }, {
      label: '停用',
      value: BOOL.FALSE
    }])
  }
}
/**
 * 启用或停用,字符编码格式  1-启用  0-停用
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const CL_EOD = {
  request: function() {
    return Promise.resolve([{
      label: '启用',
      value: '1'
    }, {
      label: '停用',
      value: '0'
    }])
  }
}

/**
 * 登录许可  1-允许  0-禁止
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const CL_ALLOW = {
  request: function() {
    return Promise.resolve([{
      label: '允许',
      value: '1'
    }, {
      label: '禁止',
      value: '0'
    }])
  }
}

//操作类型下拉框【字典数据，CODE：operation_type】
export const CL_OPERATION_TYPE = {
  labelKey: 'dataValue',
  valueKey: 'dataCode',
  request: function () {
    return listByDictCode('operation_type').then(res => {
      return res.data
    })
  }
}